var LineOfBusiness;
(function (LineOfBusiness) {
    LineOfBusiness[LineOfBusiness["Common"] = 0] = "Common";
    LineOfBusiness[LineOfBusiness["Travel"] = 1] = "Travel";
    LineOfBusiness[LineOfBusiness["Motor"] = 2] = "Motor";
    LineOfBusiness[LineOfBusiness["PersonalInjury"] = 3] = "PersonalInjury";
    LineOfBusiness[LineOfBusiness["Animal"] = 4] = "Animal";
    LineOfBusiness[LineOfBusiness["WorkersCompensation"] = 5] = "WorkersCompensation";
    LineOfBusiness[LineOfBusiness["ProfessionalAthletes"] = 8] = "ProfessionalAthletes";
    LineOfBusiness[LineOfBusiness["HealthNavigator"] = 9] = "HealthNavigator";
    LineOfBusiness[LineOfBusiness["Boat"] = 10] = "Boat";
    LineOfBusiness[LineOfBusiness["Property"] = 11] = "Property";
    LineOfBusiness[LineOfBusiness["FollowUp"] = 12] = "FollowUp";
    LineOfBusiness[LineOfBusiness["Test"] = 13] = "Test";
    LineOfBusiness[LineOfBusiness["Viking"] = 14] = "Viking";
    LineOfBusiness[LineOfBusiness["BusinessClaims"] = 16] = "BusinessClaims";
    LineOfBusiness[LineOfBusiness["Expat"] = 17] = "Expat";
    LineOfBusiness[LineOfBusiness["Mobility"] = 19] = "Mobility";
    LineOfBusiness[LineOfBusiness["ProfessionalAthletesEn"] = 20] = "ProfessionalAthletesEn";
    LineOfBusiness[LineOfBusiness["ClaimsCenter"] = 21] = "ClaimsCenter";
    LineOfBusiness[LineOfBusiness["LegalAndLiability"] = 22] = "LegalAndLiability";
    LineOfBusiness[LineOfBusiness["CarGlass"] = 23] = "CarGlass";
    LineOfBusiness[LineOfBusiness["Forest"] = 24] = "Forest";
    LineOfBusiness[LineOfBusiness["PersonalInjuryEB"] = 25] = "PersonalInjuryEB";
    LineOfBusiness[LineOfBusiness["NordicCare"] = 26] = "NordicCare";
    LineOfBusiness[LineOfBusiness["Practice"] = 100] = "Practice";
})(LineOfBusiness || (LineOfBusiness = {}));
export default LineOfBusiness;
//# sourceMappingURL=lineOfBusiness.js.map